export default __webpack_public_path__ + "static/media/icon-photo.259e6903.svg";